export const webmToWav = async (webmBlob) => {
  // Create AudioContext for decoding
  const audioContext = new AudioContext()

  // Decode WebM Blob into PCM data
  const arrayBuffer = await webmBlob.arrayBuffer()
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)

  // Extract PCM data
  const numberOfChannels = audioBuffer.numberOfChannels
  const sampleRate = audioBuffer.sampleRate
  const pcmData = []
  for (let i = 0; i < numberOfChannels; i++) {
    pcmData.push(audioBuffer.getChannelData(i))
  }

  // Encode PCM data into WAV format
  return createWavFile(pcmData, sampleRate, numberOfChannels)
}

export const writeString = (view, offset, string) => {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i))
  }
}

export const createWavFile = (pcmData, sampleRate, numberOfChannels) => {
  const bytesPerSample = 2 // 16-bit PCM
  const dataLength = pcmData[0].length * bytesPerSample * numberOfChannels
  const buffer = new ArrayBuffer(44 + dataLength)
  const view = new DataView(buffer)

  // RIFF header
  writeString(view, 0, 'RIFF')
  view.setUint32(4, 36 + dataLength, true) // File size
  writeString(view, 8, 'WAVE')

  // fmt chunk
  writeString(view, 12, 'fmt ')
  view.setUint32(16, 16, true) // fmt chunk size
  view.setUint16(20, 1, true) // Audio format (1 = PCM)
  view.setUint16(22, numberOfChannels, true) // Number of channels
  view.setUint32(24, sampleRate, true) // Sample rate
  view.setUint32(28, sampleRate * bytesPerSample * numberOfChannels, true) // Byte rate
  view.setUint16(32, bytesPerSample * numberOfChannels, true) // Block align
  view.setUint16(34, bytesPerSample * 8, true) // Bits per sample

  // data chunk
  writeString(view, 36, 'data')
  view.setUint32(40, dataLength, true) // Data chunk size

  // Write PCM data
  let offset = 44
  for (let i = 0; i < pcmData[0].length; i++) {
    for (let channel = 0; channel < numberOfChannels; channel++) {
      const sample = Math.max(-1, Math.min(1, pcmData[channel][i])) // Clamp between -1 and 1
      const intSample = sample < 0
        ? sample * 0x8000
        : sample * 0x7FFF // Convert to 16-bit PCM
      view.setInt16(offset, intSample, true)
      offset += 2
    }
  }

  return new Blob([buffer], { type: 'audio/wav' })
}
